import { appEnvironment } from '@/shared/appEnvironment';

export default {
	namespaced: true,
	state: () => ({
		rpcUrl: appEnvironment.urls.rpc,
	}),
	mutations: {
		//
	},
};
